module.exports = __webpack_public_path__ + "img/1753839541261-WhatsApp Image 2025-07-30 at 09.29.48.jpeg.1d42a3b4.webp";